import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { Text } from "@pentabd/ui";

import { InputDateController } from "./InputDateController";
import { Dayjs } from "dayjs";

interface InputDateControllerType {
  register?: any;
  control: any;
  label: string;
  required?: boolean;
  name: string;
  placeholder?: string;
  disabled?: boolean;
  errors?: any;
  portal?: boolean;
  cols?: 2 | 3 | 4 | 6;
  onSelectDate?: (date: string) => void;
  inputSize?: "xs" | "sm" | "md" | "lg";
  withoutLabel?: boolean;
  maximumDate?: Dayjs;
  minimumDate?: Dayjs;
}

export const InputDateControllerVertical = ({
  name,
  label,
  required,
  control,
  errors,
  placeholder,
  disabled,
  portal = false,
  cols,
  onSelectDate,
  inputSize = "md",
  withoutLabel,
  maximumDate,
  minimumDate,
}: InputDateControllerType) => {
  const { t } = useTranslation();

  return (
    <div
      className={classNames("col-12", {
        "col-xl-4 col-2xl-2": cols === 2,
        "col-xl-4 col-2xl-3": cols === 3,
        "col-xl-4": cols === 4,
        "col-sm-6": cols === 6,
      })}
    >
      {!withoutLabel && (
        <Text
          weight="semibold"
          color="title"
          size="sm"
          component="p"
          className="mb-3"
        >
          {t(`${label}.LABEL`)}
          {required && <span className="text-danger">&#42;</span>}
        </Text>
      )}
      <InputDateController
        control={control}
        errors={errors}
        name={name}
        placeholder={t(placeholder ? placeholder : `${label}.PLACEHOLDER`)}
        disabled={disabled}
        portal={portal}
        onSelectDate={onSelectDate}
        size={inputSize}
        minimumDate={minimumDate}
        maximumDate={maximumDate}
      />
    </div>
  );
};
